// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fa892819","667":"dae85a42"}[chunkId] + ".chunk.js";
};